module.exports = __webpack_public_path__ + "static/img/y15.664795b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y15.jpg
// module id = 3HtL
// module chunks = 1